var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 8.83331C2.46007 8.83331 2.83317 8.46022 2.83317 7.99998C2.83317 7.53974 2.46007 7.16665 1.99984 7.16665C1.5396 7.16665 1.1665 7.53974 1.1665 7.99998C1.1665 8.46022 1.5396 8.83331 1.99984 8.83331Z",
    stroke: "#081D3F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 2.99998C2.46007 2.99998 2.83317 2.62688 2.83317 2.16665C2.83317 1.70641 2.46007 1.33331 1.99984 1.33331C1.5396 1.33331 1.1665 1.70641 1.1665 2.16665C1.1665 2.62688 1.5396 2.99998 1.99984 2.99998Z",
    stroke: "#081D3F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 14.6666C2.46007 14.6666 2.83317 14.2935 2.83317 13.8333C2.83317 13.3731 2.46007 13 1.99984 13C1.5396 13 1.1665 13.3731 1.1665 13.8333C1.1665 14.2935 1.5396 14.6666 1.99984 14.6666Z",
    stroke: "#081D3F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.2978da87f8a4f7359275026937bf5f7f.svg";
export { ForwardRef as ReactComponent };